// https://www.rfc-editor.org/rfc/rfc6455.html#section-7.4.1
export enum WebSocketCodes {
  NORMAL_CLOSURE = 1000,
  EXCEPTION_CLOSURE = 1008,

  // 4000-4999 are custom codes defined by our application

  /**
   * A generic client error. Err on the side of using any of the more speciifc
   * errors below (4001+).
   */
  CLIENT_ERROR = 4000,

  /**
   * Users should refresh their boards to continue using Fabric.
   */
  SESSION_NEEDS_UPDATE = 4001,

  /**
   * Users should not reconnect automatically. Instead, it should be
   * communicated why they cannot connect.
   */
  SESSION_FULL = 4002,

  /**
   * Users should attempt to reconnect with a fresh token. Attempting
   * to reconnect with the same token will not work.
   */
  SESSION_REVOKED = 4003,

  /**
   * Users should not attempt to reconnect. The board has been archived.
   */
  SESSION_ARCHIVED = 4004,

  /**
   * Users should not attempt to reconnect. The board has been deleted.
   */
  SESSION_DELETED = 4005,

  /**
   * User attempted to access a session that did not exist in the relay
   */
  SESSION_MISSING_DATA = 4006,
}

export const webSocketCodeToName = (code: WebSocketCodes): string => {
  switch (code) {
    case WebSocketCodes.NORMAL_CLOSURE:
      return `normal_closure:${code}`;
    case WebSocketCodes.EXCEPTION_CLOSURE:
      return `exception_closure:${code}`;
    case WebSocketCodes.CLIENT_ERROR:
      return `client_error:${code}`;
    case WebSocketCodes.SESSION_NEEDS_UPDATE:
      return `session_needs_update:${code}`;
    case WebSocketCodes.SESSION_FULL:
      return `session_full:${code}`;
    case WebSocketCodes.SESSION_REVOKED:
      return `session_revoked:${code}`;
    case WebSocketCodes.SESSION_ARCHIVED:
      return `session_archived:${code}`;
    case WebSocketCodes.SESSION_DELETED:
      return `session_deleted:${code}`;
    case WebSocketCodes.SESSION_MISSING_DATA:
      return `session_missing_data:${code}`;
    default:
      return `unknown:${code}`;
  }
};
